import { Messages } from '../../config';
import { ENDPOINT_CLIENT_CAMPAIGNS } from '../../config/endpoints';
import { getAxios } from '../axios';
import {
  getTokenHeaders,
  addParam,
  errorCatch, getNotificationId,
} from '../helper';
import { store } from "../../store/store";
import { displayNotification } from "../../store/actions/notification";
import { NOTIFICATION_SUCCESS } from "../../store/actions/types";
import { HTTP_CREATED, HTTP_OK } from '../../config/constants/requestsStatuses';

/**
 * Get list of campaigns
 * @param {object} payload
 * @param {boolean} [payload.disablePagination]
 * @param {boolean} payload.hideNotification
 * @param {object} payload.pagination
 * @param {number} payload.pagination.page
 * @param {number} payload.pagination.per_page
 * @param {string} payload.pagination.sort_by
 * @param {string} payload.pagination.sort
 * @param {string} payload.pagination.q
 * @returns {Promise<T>}
 */
export function getCampaignsApi(payload) {
  if (payload && payload.disablePagination === true) {
    if (!payload.pagination) {
      payload.pagination = {};
    }

    payload.pagination.per_page = 100000;
  }

  return getAxios(payload.hideNotification).get(
    addParam(
      ENDPOINT_CLIENT_CAMPAIGNS,
      {
        '{campaign}': '',
      }
    ),
    getTokenHeaders(payload.pagination || null)
  )
    .then(response => {
      return response && response.data ? response.data : null
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        });

        return e.response;
      }
    );
}

/**
 * Create a campaign
 * @param {object} payload
 * @param {string} payload.notificationId
 * @param {object} payload.data
 * @param {string} payload.data.name
 * @param {string} payload.data.notes
 * @param {string} payload.data.start_date
 * @param {string} payload.data.end_date
 * @param {object} payload.data.tracking
 * @param {object} payload.data.campaign_trackings.tracking_label
 * @param {object} payload.data.campaign_trackings.tracking_id
 * @returns {Promise<T>}
 */
export function createCampaign(payload) {
  return getAxios().post(
      addParam(
        ENDPOINT_CLIENT_CAMPAIGNS,
        {
          "{campaign}": "",
        }
      ),
      payload.data,
      getTokenHeaders()
    ).then(
      response => {
        if (response && response.status === HTTP_CREATED) {
          store.dispatch(displayNotification(NOTIFICATION_SUCCESS, Messages.CREATE_RESOURCE_SUCCESS, payload.notificationId || null));
          return response.data;
        }

        return null;
      }
    ).catch(
      e => {
        errorCatch( e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        }, getNotificationId( payload ) );

        return e.response;
      }
    );
}

/**
 * Get campaign
 * @param {object} payload
 * @param {string} [payload.id]
 * @param {boolean} payload.hideNotification
 * @returns {Promise<T>}
 */
export function getCampaignApi(payload) {
  return getAxios(payload.hideNotification).get(
    addParam(
      ENDPOINT_CLIENT_CAMPAIGNS,
      {
        '{campaign}': payload.id,
      }
    ),
    getTokenHeaders()
  )
    .then(response => {
      return response && response.data ? response.data : null;
    })
    .catch(
      e => {
        errorCatch(e, {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        });

        return e.response;
      }
    );
}

/**
 * Create a campaign
 * @param {object} payload
 * @param {string} payload.id
 * @param {string} payload.notificationId
 * @param {object} payload.data
 * @param {string} payload.data.name
 * @param {string} payload.data.notes
 * @param {string} payload.data.start_date
 * @param {string} payload.data.end_date
 * @param {object} payload.data.tracking
 * @param {object} payload.data.campaign_trackings.tracking_label
 * @param {object} payload.data.campaign_trackings.tracking_id
 * @returns {Promise<T>}
 */
export function updateCampaign(payload) {
  return getAxios().put(
    addParam(
      ENDPOINT_CLIENT_CAMPAIGNS,
      {
        "{campaign}": payload.id,
      }
    ),
    payload.data,
    getTokenHeaders()
  ).then(
    response => {
      if (response && response.status === HTTP_OK) {
        store.dispatch(displayNotification(NOTIFICATION_SUCCESS, Messages.UPDATE_RESOURCE_SUCCESS, payload.notificationId || null));
        return response.data;
      }

      return null;
    }
  ).catch(
    e => {
      errorCatch( e, {
        400: 'concat',
        401: Messages.UNAUTHENTICATED_ERROR,
        403: Messages.UNAUTHORIZED_ERROR,
        404: Messages.NOT_FOUND_ERROR,
      }, getNotificationId( payload ) );

      return e.response;


    }
  );
}
